import { render, staticRenderFns } from "./GroupMemberNew.vue?vue&type=template&id=5d328fd0&scoped=true"
import script from "./GroupMemberNew.vue?vue&type=script&lang=js"
export * from "./GroupMemberNew.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberNew.vue?vue&type=style&index=0&id=5d328fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d328fd0",
  null
  
)

export default component.exports